import React from "react";
import { BasicLogo } from "../Brand/BasicLogo";

export const FooterLogo = () => {
  return <BasicLogo />;
};
